import {StringHelper} from "./string.helper";

export class HtmlHelper {

    public static createDiv(cssClasses = [], children = [], id = null): HTMLDivElement {
        const node = document.createElement('DIV') as HTMLDivElement;
        node.classList.add(...cssClasses.filter(Boolean));
        node.append(...children);

        if (id) {
            node.id = id;
        }

        return node;
    }

    public static createNode(type: string, attributes: [string, string][], children: string | HTMLElement[] = []): HTMLElement {
        const node = document.createElement(type);
        for (let [key, value] of attributes) {
            node.setAttribute(key, value);
        }

        if (typeof children === "string") {
            node.innerHTML = children;
        } else {
            node.append(...children);
        }

        return node;
    }

    public static createLink(href: string | null = null, cssClasses: string[] = [], target = '_blank', children: string | HTMLElement[] = []) {
        const node: HTMLLinkElement = document.createElement('A') as HTMLLinkElement;
        node.classList.add(...cssClasses.filter(Boolean));
        if (href) {
            node.href = href;
        }
        if (target) {
            node.target = target;
        }
        node.append(...children);

        return node;
    }

    public static addData(node: HTMLElement, key_value_pairs: [string, any][] = []): HTMLElement {
        for (let [key, value] of key_value_pairs) {
            node.dataset[key] = value;
        }

        return node;
    }

    public static svgStringToDataUrl(svgString: string): string {
        return `data:image/svg+xml;charset=UTF-8  ,${encodeURIComponent(svgString.trim())}`
    }

    public static removeElement(element: HTMLElement): void {
        if (!element.parentNode) {
            return;
        }

        element.parentNode.removeChild(element);
    }

    public static setGlobalVar(varName: string, value: any): void {
        document.body.parentElement?.style.setProperty(`--${StringHelper.toKebabCase(varName)}`, "" + value);
    }

    public static getGlobalVar(varName: string): string | null {
        return document.body.parentElement?.style.getPropertyValue(`--${StringHelper.toKebabCase(varName)}`) ?? null;
    }
}